import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { TableOfContentOrientationEnum } from '../../enums/table-of-content-orientation.enum';
import { TextStyleFieldModel } from '../../../../Common/PageBuilder/models/text-style-field.model';
import { MonitoringTextStyleModel } from '../../../Shared/models/monitoring-text-style.model';
import { TableOfContentFeaturesEnum } from '../../enums/table-of-content-features.enum';
import { TableOfContentSettingsModel } from '../../models/table-of-content-settings.model';
import { briefingHeadingLevelOptions } from '../../models/briefing-heading-level.model';

@Component({
    selector: 'agpr-table-of-content-settings',
    templateUrl: './table-of-content-settings.component.html',
    styleUrls: ['./table-of-content-settings.component.scss'],
    standalone: false
})
export class TableOfContentSettingsComponent extends AbstractFormFieldComponent implements OnInit, OnChanges {
    @Input() declare value: TableOfContentSettingsModel;

    selectedOrientation: TableOfContentOrientationEnum;
    tableOfContentOrientationEnum = TableOfContentOrientationEnum;

    includeMentionSections: boolean;
    includeMentionCount: boolean;
    includeHeadlines: boolean;
    includeTitle: boolean;

    fontStyleField: TextStyleFieldModel;
    fontStyle: MonitoringTextStyleModel;

    selectedFeatures: TableOfContentFeaturesEnum;
    tableOfContentFeaturesEnum = TableOfContentFeaturesEnum;

    dropdownLevelOptions = briefingHeadingLevelOptions;
    selectedTitleLevel;

    constructor() {
        super();
    }

    ngOnInit() {
        if (!this.value) {
            this.value = new TableOfContentSettingsModel();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('value')) {
            if (!this.value) {
                this.value = new TableOfContentSettingsModel();
            }

            this.selectedOrientation = this.value.orientation;
            this.includeMentionSections = this.value._includeMentionSections;
            this.includeMentionCount = this.value.includeMentionCount;
            this.includeHeadlines = this.value.includeHeadlines;
            this.includeTitle = this.value.includeTitle;
            this.selectedTitleLevel = this.dropdownLevelOptions.find(item => item.value === this.value.titleLevel);
        }
    }

    /**
     * Handles changes to the seleted orientation
     */
    orientationChange(): void {
        this.value.orientation = this.selectedOrientation;
        this.value.changeOrientation(this.value.orientation);
        this.handleChange();
    }
    /**
     * Handles changes to the settings model
     */
    handleChange(): void {
        this.value._includeMentionSections = this.includeMentionSections;
        this.value.includeMentionCount = this.includeMentionCount;
        this.value.includeHeadlines = this.includeHeadlines;
        this.value.includeTitle = this.includeTitle;
        this.value.titleLevel = this.selectedTitleLevel.value;

        this.changes.emit(this.value);
    }
}
